// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Pill_badgeWrapper__q0u9T","removeButton":"Pill_removeButton__C4lTp"};